export default {"src":"/_next/static/media/slide-predictable-icon.e6a83213.svg","height":77,"width":77};